import ReCAPTCHA from 'react-google-recaptcha';

const { REACT_APP_CAPTCHA_SITE_KEY } = process.env;
export const captchaSiteKey =
  REACT_APP_CAPTCHA_SITE_KEY || '6LdBiUEaAAAAADB4BvkgpkfP0NHPvaiEFXiLNRBQ';

export default ReCAPTCHA;
